module.exports = __webpack_public_path__ + "static/media/card-sim.044e1f7a.png";